"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaymentAccountAddress = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const lodash_1 = require("lodash");
/**
 * Gets the address info off a PaymentAccount.
 *
 * This should only be used if saved payments are represented using PaymentAccount and
 * stored in CustomerServices. Otherwise SavedPaymentMethod should be used instead.
 *
 * @deprecated In favor of using SavedPaymentMethod and PaymentTransactionServices to manage saved payment methods.
 */
const usePaymentAccountAddress = (paymentAccount) => {
    return (0, react_1.useMemo)(() => {
        if (!paymentAccount) {
            return undefined;
        }
        return (0, lodash_1.pick)(paymentAccount, [
            'fullName',
            'addressLine1',
            'addressLine2',
            'city',
            'stateProvinceRegion',
            'postalCode',
            'country',
            'phonePrimary'
        ]);
    }, [paymentAccount]);
};
exports.usePaymentAccountAddress = usePaymentAccountAddress;
//# sourceMappingURL=use-payment-account-address.js.map